// Resolve Query Use Case
import { QueriesRepository } from "../repositories/QueriesRepository";
import { QueryEntity, QueryStatus } from "../entities/QueryEntity";
import { Result } from "../common/Result";

export class ResolveQueryUseCase {
  constructor(private repository: QueriesRepository) {}

  async execute(queryId: number): Promise<Result<QueryEntity>> {
    try {
      if (!queryId || queryId <= 0) {
        return Result.fail("Invalid query ID");
      }

      // Fetch query details to validate
      const query = await this.repository.getDetails(queryId);

      // Check if already resolved
      if (
        query.status === QueryStatus.RESOLVED ||
        query.status === QueryStatus.CLOSED
      ) {
        return Result.fail(`Query is already ${query.status}`);
      }

      // Frontend validation: Check for unresolved sub-queries
      if (query.subQueries && query.subQueries.length > 0) {
        const unresolved = query.subQueries.filter(
          (sq) =>
            sq.status !== QueryStatus.RESOLVED &&
            sq.status !== QueryStatus.CLOSED
        );

        if (unresolved.length > 0) {
          return Result.fail(
            `Cannot resolve query. ${unresolved.length} sub-${
              unresolved.length === 1 ? "query is" : "queries are"
            } still unresolved.`
          );
        }
      }

      // Call repository to resolve (backend will also validate)
      const resolvedQuery = await this.repository.resolve(queryId);
      return Result.ok(resolvedQuery);
    } catch (error: any) {
      return Result.fail(error.message || "Failed to resolve query");
    }
  }
}

